export function focus(pen, ctx) {
  const path = !ctx ? new Path2D() : ctx;
  const {x, y, width, height} = pen.calculative.worldRect;
  path.rect(x, y, width, height);

  path.closePath();
  if (path instanceof Path2D) return path;
}
